import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function NewsFooter() {
  return (
    <footer className="bg-[#0A0E27] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/27f9ab70-330d-4ebc-8660-fbee76b65610.png"
                alt="Teknonova"
                className="h-8 w-auto object-contain"
              />
              <span className="text-white font-bold text-lg">Teknonova</span>
            </Link>
            <p className="text-white/40 text-sm leading-relaxed">
              Teknoloji dünyasından en güncel haberler, incelemeler ve analizler.
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Kategoriler</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/kategori/${cat.id}`}
                    className="text-white/40 text-sm hover:text-[#00D9FF] transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Hızlı Linkler</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-white/40 text-sm hover:text-[#00D9FF] transition-colors cursor-pointer">Ana Sayfa</Link></li>
              <li><Link to="/haberler" className="text-white/40 text-sm hover:text-[#00D9FF] transition-colors cursor-pointer">Tüm Haberler</Link></li>
              <li><Link to="/populer" className="text-white/40 text-sm hover:text-[#00D9FF] transition-colors cursor-pointer">Popüler Haberler</Link></li>
              <li><Link to="/okuma-listesi" className="text-white/40 text-sm hover:text-[#00D9FF] transition-colors cursor-pointer">Okuma Listesi</Link></li>
              <li><Link to="/abonelik" className="text-white/40 text-sm hover:text-[#00D9FF] transition-colors cursor-pointer">Bülten Aboneliği</Link></li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Sosyal Medya</h4>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-twitter-x-line', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-youtube-line', href: '#' },
                { icon: 'ri-linkedin-line', href: '#' },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-white/5 rounded-full text-white/60 hover:bg-[#00D9FF] hover:text-[#0A0E27] transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">&copy; 2025 Teknonova. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">Gizlilik</a>
            <a href="#" rel="nofollow" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">Kullanım Koşulları</a>
            <Link to="/admin" className="text-white/10 text-xs hover:text-white/30 transition-colors cursor-pointer">Yönetim</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
